import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Zap, Users, CreditCard, Search, Shield, AlertTriangle, Activity, BarChart3, Server, TrendingUp, DollarSign, Settings, Ban, SlidersHorizontal, Globe, Mail , FileText, Trash2 } from 'lucide-react';

const TABS = [
  { id: 'dashboard', icon: <BarChart3 size={14} />, label: 'Dashboard', path: '/dashboard/admin' },
  { id: 'users', icon: <Users size={14} />, label: 'Users', path: '/dashboard/admin/users' },
  { id: 'billing', icon: <CreditCard size={14} />, label: 'Billing', path: '/dashboard/admin/billing' },
  { id: 'detections', icon: <AlertTriangle size={14} />, label: 'Detections', path: '/dashboard/admin/detections' },
  { id: 'diagnostics', icon: <Activity size={14} />, label: 'Diagnostics', path: '/dashboard/admin/diagnostics' },
  { id: 'tokens', icon: <Zap size={14} />, label: 'Token Usage', path: '/dashboard/admin/tokens' },
  { id: 'visitors', icon: <Globe size={14} />, label: 'Visitors', path: '/dashboard/admin/visitors' },
  { id: 'analytics', icon: <TrendingUp size={14} />, label: 'Analytics', path: '/dashboard/admin/analytics' },
  { id: 'expenses', icon: <DollarSign size={14} />, label: 'Expenses', path: '/dashboard/admin/expenses' },
  { id: 'ratelimits', icon: <Ban size={14} />, label: 'Rate Limits', path: '/dashboard/admin/ratelimits' },
  { id: 'config', icon: <Settings size={14} />, label: 'Config', path: '/dashboard/admin/config' },
  { id: 'operations', icon: <SlidersHorizontal size={14} />, label: 'Operations', path: '/dashboard/admin/operations' },
  { id: 'coming-soon', icon: <Mail size={14} />, label: 'Coming Soon', path: '/dashboard/admin/coming-soon-subscribers' },
  { id: 'crypto', icon: <DollarSign size={14} />, label: 'Crypto Payments', path: '/dashboard/admin/crypto-payments' },
  { id: 'review', icon: <Shield size={14} />, label: 'Reg Review', path: '/dashboard/admin/registration-review' },
  { id: 'deleted', icon: <Trash2 size={14} />, label: 'Deleted Accounts', path: '/dashboard/admin/deleted-accounts' },
  { id: 'dpa', icon: <FileText size={14} />, label: 'DPA Agreements', path: '/dashboard/admin/dpa' },
  { id: 'health', icon: <Server size={14} />, label: 'Server Health', path: '/dashboard/admin/health' },
  { id: 'diagnostics', icon: <Search size={14} />, label: 'Search Diagnostics', path: '/dashboard/admin/search-diagnostics' },
  { id: 'audit', icon: <Shield size={14} />, label: 'Audit Logs', path: '/dashboard/admin/audit-logs' },
  { id: 'reset', icon: <Shield size={14} />, label: 'System Reset', path: '/dashboard/admin/reset' },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    const path = location.pathname;
    if (path === '/dashboard/admin' || path === '/dashboard/admin/') return 'dashboard';
    if (path.includes('/users')) return 'users';
    if (path.includes('/billing')) return 'billing';
    if (path.includes('/detections')) return 'detections';
    if (path.includes('/diagnostics')) return 'diagnostics';
    if (path.includes('/tokens')) return 'tokens';
    if (path.includes('/visitors')) return 'visitors';
    if (path.includes('/ratelimits')) return 'ratelimits';
    if (path.includes('/config')) return 'config';
    if (path.includes('/expenses')) return 'expenses';
    if (path.includes('/analytics')) return 'analytics';
    if (path.includes('/health')) return 'health';
    if (path.includes('/diagnostics')) return 'diagnostics';
    if (path.includes('/audit')) return 'audit';
    if (path.includes('/reset')) return 'reset';
    if (path.includes('/operations')) return 'operations';
    if (path.includes('/crypto-payments')) return 'crypto';
    if (path.includes('/registration-review')) return 'review';
    if (path.includes('/deleted-accounts')) return 'deleted';
    return 'dashboard';
  };

  const activeTab = getActiveTab();

  return (
    <div>
      {/* Horizontal tab bar */}
      <div style={{
        display: 'flex', gap: 6, marginBottom: 'var(--space-2xl)',
        overflowX: 'auto', paddingBottom: 4,
      }}>
        {TABS.map(tab => (
          <button key={tab.id} onClick={() => navigate(tab.path)} style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '8px 16px', borderRadius: 10, border: 'none',
            cursor: 'pointer', fontSize: 13, fontWeight: 600,
            whiteSpace: 'nowrap', flexShrink: 0,
            background: activeTab === tab.id ? 'var(--accent-glow)' : 'transparent',
            color: activeTab === tab.id ? 'var(--accent-primary)' : 'var(--text-secondary)',
            transition: 'all 0.15s ease',
          }}>
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      {/* Page content */}
      <Outlet />
    </div>
  );
}
